import React from 'react'
import mainContentStar from '../assets/img/grafika/ZVIJEZDA-natpis-HR.png'
import mainContentPrizes from '../assets/img/HR-ZBIRNE-nagrade.png'

const DobitniciContent = () => {

  return (
    <article className="mainContent pb-4">
      <div className="px-2 lg:px-9 mt-10 lg:mt-2">
        <h3 className="font-bold text-xl sm:text-2xl lg:text-3xl max-w-[60ch] mx-auto mb-6 lg:mb-6">Dobitnici</h3>
        <div className="flex flex-wrap justify-between">
          <div className="flex-1 min-w-full md:min-w-[33%] px-0 md:px-2 mb-8">
          <p className='font-bold'>10 x friteza na vrući zrak</p>
          
            <p>Ante Vuletić, Neum</p>
          
            <p>Iman Bobar, Prozor</p>
            
            <p>Faruk Kurtović, Sarajevo</p>
            
            <p>Ivana Kikaš, Međugorje</p>
           
            <p>Aldina Šebo, Sarajevo</p>
           
            <p>Josipa Komšić, Mostar</p>
           
            <p>Samra Ćufurović, Vrnogorac</p>
            
            <p>Ivana Gotovac, Travnik</p>
           
            <p>Alma Ramcilovic, Sarajevo</p>
            
            <p>Amra Šaković, Sarajevo</p>
          </div>
          
        </div>
      </div>
    </article>
  )

}

export default DobitniciContent